// Extend the theme's disclosure only for the three desktop editorial menus.
// Keep its hover tolerance, touch detection, keyboard navigation and focus restoration.
import 'theme';
import { animate } from 'vendor';

const NativeDisclosure = customElements.get('dropdown-menu-disclosure');
class RymarDesktopDisclosure extends NativeDisclosure {
  connectedCallback() {
    super.connectedCallback();
    this.controller = new AbortController();
    document.addEventListener('pointerdown', (event) => {
      if (!this.contains(event.target)) this.close();
    }, { signal: this.controller.signal });
    this.desktopQuery = matchMedia('(min-width: 1000px)');
    this.desktopQuery.addEventListener('change', () => {
      if (!this.desktopQuery.matches) this.close();
    }, { signal: this.controller.signal });
    this.positionObserver = new ResizeObserver(() => this.positionPanel());
    this.positionObserver.observe(this.closest('.header'));
    this.positionObserver.observe(this.summaryElement);
    window.addEventListener('resize', () => this.positionPanel(), { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.close();
    this.controller.abort();
    this.positionObserver.disconnect();
    super.disconnectedCallback();
  }

  open(options = {}) {
    if (!matchMedia('(min-width: 1000px)').matches) return;
    this.closest('.header__primary-nav').querySelectorAll('rymar-desktop-disclosure').forEach((sibling) => {
      if (sibling !== this) sibling.close();
    });
    return super.open(options);
  }

  positionPanel() {
    if (!this.disclosureElement.open || !this.desktopQuery.matches) return;
    const panel = this.contentElement;
    const trigger = this.summaryElement.getBoundingClientRect();
    const header = this.closest('.header').getBoundingClientRect();
    const width = panel.getBoundingClientRect().width;
    let left = trigger.left;
    if (panel.classList.contains('rymar-editorial-menu--locations')) {
      left = trigger.left + (trigger.width - width) / 2;
    } else if (panel.classList.contains('rymar-editorial-menu--contact')) {
      left = trigger.right - width;
    }
    // Anchor to the trigger, keeping the panel inside the viewport's 24px gutters.
    left = Math.max(24, Math.min(left, document.documentElement.clientWidth - width - 24));
    panel.style.setProperty('--rymar-panel-left', `${left - header.left}px`);
  }

  createShowAnimationControls() {
    this.positionPanel();
    this.panelAnimation?.cancel();
    this.panelAnimation = animate(this.contentElement, { opacity: [0, 1] }, {
      duration: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 0.12
    });
    return this.panelAnimation;
  }

  createHideAnimationControls() {
    this.panelAnimation?.cancel();
    // Close immediately so sibling panels cannot overlap or retain hidden focus targets.
    this.disclosureElement.open = false;
    this.contentElement.style.opacity = '0';
  }
}
if (!customElements.get('rymar-desktop-disclosure')) {
  customElements.define('rymar-desktop-disclosure', RymarDesktopDisclosure);
}
